
/* ============================================================================
FILE: po-katupirsia5-sceau-d-oendomare-texts-fr-en-es-20260307.js

MODE: TRILINGUE (FR/EN/ES) + lexicon injection (if present)

API:  window.PoKatupirsia5SceauDOendomareTextsFR_EN_ES_20260307

ROOT: .po-axis-section[data-po-axis="sceau_d_oendomare"]

ROLE:
  - Injecte le contenu FR/EN/ES dans les slots selon la langue (navigateur ou storage).
  - Protection fine: verrouille (translate="no") TOUTES les occurrences du lexique simplifié (si disponible),
    avec variantes apostrophes + œ/oe, et anti-collage (espaces DOM/HTML uniquement quand nécessaire).
  - IMPORTANT: les termes du lexique (et variantes) restent en FR, quelle que soit la langue affichée.
  - Compat: conserve un alias API window.GoodyTwinLang (getLang/setLang/init) pour éviter de casser d’anciens appels.
  - Ajoute une couche audio locale et générale sans toucher au socle multilingue,
    ni au nom du fichier.
============================================================================ */

(function(){

  "use strict";

  if (window.__PO_KATUPIRSIA5_SCEAU_D_OENDOMARE_TEXTS_20260307__) return;
  window.__PO_KATUPIRSIA5_SCEAU_D_OENDOMARE_TEXTS_20260307__ = true;

  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AXIS_LEX_ID = "sceau_d_oendomare";
  var ROOT_SEL =
    '.po-axis-section[data-po-axis="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-lex-id="' + AXIS_LEX_ID + '"]';

  var IMG_IDEOGRAM_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Oendomare_421_2.png?v=1772906456";
  var IMG_IDEOGRAM_FUNCTION = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Oendomare_421_3_copie_2.png?v=1772906531";
  var IMG_GUIDE_NUMBER_421 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_421.png?v=1773449520";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang(){
    try{
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    }catch(e){}
    try{
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    }catch(e){}
    return "";
  }

  function storeLang(lang){
    var v = normLang(lang) || "fr";
    try{ localStorage.setItem(STORAGE_KEY, v); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, v); }catch(e){}
    try{ document.documentElement.setAttribute("lang", v); }catch(e){}
    return v;
  }

  function detectBrowserLang(){
    try{
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    }catch(e){}
    return "fr";
  }

  function getLang(){
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}

    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}

    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    var ks = "definition_short_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k])  return clampStr(entry[k]);
    }catch(e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    var kl = "definition_long_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k])  return clampStr(entry[k]);
    }catch(e){}
    return "";
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + "_" + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  /* --------------------------------------------------------------------------
   * PROTECTION fine
   * -------------------------------------------------------------------------- */

  function protectSpan(txt){
    return '<span translate="no" class="po-lex-protect notranslate">' + clampStr(txt) + "</span>";
  }

  function uniqPush(arr, v){
    if (!v) return;
    for (var i=0;i<arr.length;i++){
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term){
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1);
    uniqPush(out, oe2);
    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta &&
          Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)){
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)){
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    }catch(e){}

    return [
      "Sceau d’Œndomare","Œndomare","Œndomarê","Posœnnoïsme","Posœnnoïa","Organon posœnnoïal",
      "Katûvýsissence","Katûvýs","Ennéagone","Isqun","Threnisqun","Extratinrieur","Posœnnomia",
      "RéZonans","Péroptissimisme","Aliœvolution","Illusion","Addition synchrêtique","Instantané multiple",
      "Superposition de perspectives","Sujet pluriel","Humanus","Balakallpa","Katûsýs","Katûvýsqun",
      "Tiqqunbahu","Mathêsis ontologique posœnnoïale"
    ];
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function buildProtectMatcher(){
    var base = getSimplifiedLexiqueFRList();
    var variants = [];
    for (var i=0;i<base.length;i++){
      var vlist = buildVariants(base[i]);
      for (var j=0;j<vlist.length;j++) uniqPush(variants, vlist[j]);
    }
    variants.sort(function(a,b){ return b.length - a.length; });
    var parts = [];
    for (var k=0;k<variants.length;k++){
      if (variants[k]) parts.push(escapeRegExp(variants[k]));
    }
    if (!parts.length) return null;
    try{ return new RegExp("(" + parts.join("|") + ")", "g"); }catch(e){ return null; }
  }

  var __PO_PROTECT_RE__ = null;

  function protectKeywordsHTML(html){
    if (!html) return "";
    var out = String(html);
    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (__PO_PROTECT_RE__){
      out = out.replace(__PO_PROTECT_RE__, function(m){ return protectSpan(m); });
    }
    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect notranslate">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect notranslate">)/g, function(_m, a, b){
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });
    return out;
  }

  /* --------------------------------------------------------------------------
   * SLOTS helpers
   * -------------------------------------------------------------------------- */

  function qs(root, sel){
    try{ return root.querySelector(sel); }catch(e){ return null; }
  }

  function setSlotText(root, slot, txt){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(clampStr(html));
  }

  function setSlotImg(root, slot, src, alt){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var s = clampStr(src);
    var a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt",""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }
    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function renderList(root, slot, items){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      out.push("<li>" + protectKeywordsHTML(clampStr(arr[i])) + "</li>");
    }
    el.innerHTML = out.join("");
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var t = clampStr(exampleTitle);
    var x = clampStr(exampleText);
    if (!t && !x){ el.innerHTML = ""; return; }
    var html =
      '<div class="po-lex-example__title"><strong>' + protectKeywordsHTML(t) + '</strong></div>' +
      '<div class="po-lex-example__text">' + protectKeywordsHTML(x) + "</div>";
    el.innerHTML = html;
  }

  function renderWordBlocks(root, slot, blocks){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(clampStr(b.head || "")) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(clampStr(b.text || "")).replace(/\n/g, "<br />") + '</div>' +
        '</div>'
      );
    }
    el.innerHTML = out.join("");
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:"", lang:"fr", voice:null };
  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){ var L = normLang(lang); return AUDIO_UI[L] || AUDIO_UI.fr; }
  function getAudioRoots(){ try{ return document.querySelectorAll(ROOT_SEL); }catch(e){ return []; } }
  function getDetailBlocks(root){ if (!root || !root.querySelectorAll) return []; try{ return root.querySelectorAll('.po-lex-details'); }catch(e){ return []; } }

  function ensureAudioStyles(){
    if (document.getElementById('po-axis-audio-styles')) return;
    var style = document.createElement('style');
    style.id = 'po-axis-audio-styles';
    style.textContent =
      '.po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;justify-content:flex-start;}' +
      '.po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(184,134,11,.55);background:rgba(31,122,58,.04);color:var(--color-accent,#1f7a3a);padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;font-weight:800;line-height:1.2;transition:opacity .2s ease,transform .2s ease,box-shadow .2s ease,border-color .2s ease;box-shadow:0 6px 16px rgba(31,122,58,.10);}' +
      '.po-axis-audio-btn:hover{transform:translateY(-1px);box-shadow:0 10px 26px rgba(31,122,58,.16);border-color:rgba(184,134,11,.75);}' +
      '.po-axis-audio-btn[aria-pressed="true"]{box-shadow:0 0 0 1px rgba(184,134,11,.18),0 10px 26px rgba(31,122,58,.18);background:rgba(31,122,58,.08);}' +
      '.po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;flex:0 0 auto;}' +
      '@media (max-width:640px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}';
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role === 'general' ? 'general' : 'detail');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('translate', 'yes');
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();
    var panel = root.querySelector('.po-lex-panel');
    if (panel){
      var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap){
        generalWrap = document.createElement('div');
        generalWrap.className = 'po-axis-audio-wrap';
        generalWrap.setAttribute('data-po-audio-role', 'general');
        generalWrap.appendChild(createAudioButton('general'));

        var meta = root.querySelector('.po-axis-meta');
        var defShort = root.querySelector('[data-po-slot="def_short"]');
        var firstDetail = panel.querySelector('.po-lex-details');
        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        } else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var summary = details[i].querySelector('.po-lex-summary');
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"]');
      if (!btn){
        btn = createAudioButton('detail');
        summary.appendChild(btn);
      }
      btn.setAttribute('data-po-audio-index', String(i));
    }
  }

  function getTextValue(el){
    if (!el) return '';
    var txt = '';
    try{ txt = el.innerText || el.textContent || ''; }catch(e){ txt = ''; }
    return String(txt).replace(/\s+/g, ' ').replace(/\u00a0/g, ' ').trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn, .po-axis-audio-wrap');
    for (var i=0;i<btns.length;i++){
      if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
    }
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ['title','kicker','h_def','def_short','def_long'];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join('. ');
  }

  function collectDetailText(detail){
    if (!detail) return '';
    var parts = [];
    var title = detail.querySelector('.po-lex-summary__title');
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);
    var clone = detail.cloneNode(true);
    var summary = clone.querySelector('.po-lex-summary');
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);
    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join('. ');
  }

  function isWordLikeChar(ch){ return /[0-9A-Za-zÀ-ÖØ-öø-ÿ]/.test(ch || ''); }

  function splitTextForSpeech(txt, maxLen){
    var text = clampStr(txt).replace(/\s+/g, ' ').trim();
    if (!text) return [];
    var limit = Math.max(120, parseInt(maxLen, 10) || 200);
    var out = [];
    var start = 0;
    while (start < text.length){
      var end = Math.min(start + limit, text.length);
      if (end < text.length){
        var slice = text.slice(start, end);
        var cut = Math.max(slice.lastIndexOf('. '), slice.lastIndexOf('! '), slice.lastIndexOf('? '), slice.lastIndexOf('; '), slice.lastIndexOf(': '), slice.lastIndexOf(', '));
        if (cut < Math.floor(limit * 0.55)) cut = slice.lastIndexOf(' ');
        if (cut > 0) end = start + cut + 1;
      }
      while (end < text.length && isWordLikeChar(text.charAt(end - 1)) && isWordLikeChar(text.charAt(end))){
        end++;
      }
      var chunk = text.slice(start, end).trim();
      if (chunk) out.push(chunk);
      start = end;
    }
    return out;
  }

  function pickVoiceForLang(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== 'function') return null;
    var wanted = normLang(lang) || 'fr';
    var voices = [];
    try{ voices = PO_AUDIO_SYNTH.getVoices() || []; }catch(e){ voices = []; }
    if (!voices.length) return null;
    for (var i=0;i<voices.length;i++){
      if (normLang(voices[i] && voices[i].lang) === wanted) return voices[i];
    }
    for (var j=0;j<voices.length;j++){
      var voiceLang = clampStr(voices[j] && voices[j].lang).toLowerCase();
      if (voiceLang.indexOf(wanted) === 0) return voices[j];
    }
    return voices[0] || null;
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);
    if (role === 'general'){
      units.push({ role:'general', index:-1 });
      for (var i=0;i<details.length;i++) units.push({ role:'detail', index:i });
      return units;
    }
    var start = (typeof index === 'number' && index >= 0) ? index : 0;
    for (var j=start;j<details.length;j++) units.push({ role:'detail', index:j });
    return units;
  }

  function updateAudioPressedState(){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      var btns = roots[i].querySelectorAll('.po-axis-audio-btn');
      for (var j=0;j<btns.length;j++) btns[j].setAttribute('aria-pressed', 'false');
    }
    if (!PO_AUDIO_STATE.root || !PO_AUDIO_STATE.activeKey) return;
    var btn;
    if (PO_AUDIO_STATE.activeKey === 'general'){
      btn = PO_AUDIO_STATE.root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"] .po-axis-audio-btn[data-po-audio-role="general"]');
      if (btn) btn.setAttribute('aria-pressed', 'true');
      return;
    }
    var idx = parseInt(String(PO_AUDIO_STATE.activeKey).split(':')[1], 10);
    if (!isNaN(idx)){
      btn = PO_AUDIO_STATE.root.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"][data-po-audio-index="' + idx + '"]');
      if (btn) btn.setAttribute('aria-pressed', 'true');
    }
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang || getLang());
    var generalBtn = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"] .po-axis-audio-btn[data-po-audio-role="general"]');
    if (generalBtn){
      var generalActive = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === 'general' && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      generalBtn.textContent = generalActive ? ui.stop : ui.general;
    }
    var detailBtns = root.querySelectorAll('.po-axis-audio-btn[data-po-audio-role="detail"]');
    for (var i=0;i<detailBtns.length;i++){
      var btn = detailBtns[i];
      var idx = parseInt(btn.getAttribute('data-po-audio-index'), 10);
      var key = 'detail:' + (isNaN(idx) ? -1 : idx);
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      btn.textContent = active ? ui.stop : ui.block;
    }
    updateAudioPressedState();
  }

  function refreshAllAudioLabels(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++) refreshAudioLabels(roots[i], lang || getLang());
  }

  function stopAudio(silent){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.voice = null;
    if (!silent) refreshAllAudioLabels(getLang());
    else updateAudioPressedState();
  }

  function speakCurrentChunk(){
    if (!PO_AUDIO_SYNTH) return;
    if (!PO_AUDIO_STATE.chunks.length || PO_AUDIO_STATE.chunkPos < 0 || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }
    var txt = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!txt){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
      return;
    }
    var utter = new SpeechSynthesisUtterance(txt);
    utter.lang = (PO_AUDIO_STATE.lang || getLang() || 'fr');
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.onend = function(){ PO_AUDIO_STATE.chunkPos += 1; speakCurrentChunk(); };
    utter.onerror = function(){ PO_AUDIO_STATE.chunkPos += 1; speakCurrentChunk(); };
    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ PO_AUDIO_STATE.chunkPos += 1; speakCurrentChunk(); }
  }

  function playCurrentUnit(skipCancel){
    if (!PO_AUDIO_SYNTH) return;
    if (!skipCancel){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    if (!PO_AUDIO_STATE.root || PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit){ stopAudio(); return; }

    var text = '';
    if (unit.role === 'general'){
      PO_AUDIO_STATE.activeKey = 'general';
      text = collectGeneralText(PO_AUDIO_STATE.root);
    }else{
      PO_AUDIO_STATE.activeKey = 'detail:' + unit.index;
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail){
        try{ detail.open = true; }catch(e){}
      }
      text = collectDetailText(detail);
    }

    PO_AUDIO_STATE.chunks = splitTextForSpeech(text, 210);
    PO_AUDIO_STATE.chunkPos = 0;
    refreshAllAudioLabels(PO_AUDIO_STATE.lang || getLang());

    if (!PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }
    speakCurrentChunk();
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio(true);
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);
    refreshAllAudioLabels(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    for (var i=0;i<btns.length;i++){
      if (btns[i].__poAudioBound) continue;
      btns[i].addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute('data-po-audio-role') || 'detail';
        var index = parseInt(this.getAttribute('data-po-audio-index'), 10);
        var key = (role === 'general') ? 'general' : ('detail:' + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)){
          stopAudio();
          return;
        }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btns[i].__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === 'function'){
      PO_AUDIO_SYNTH.addEventListener('voiceschanged', function(){
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * FALLBACKS
   * -------------------------------------------------------------------------- */

  var FALLBACK_FR = {
    title: "Sceau d’Œndomare",
    kicker: "Katûpirsia 5 — Sceau régulateur de l’Ennéagone spiralé",
    cta_translate: "Proposer une traduction du concept",
    h_def: "Définition opérative",
    chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel", "Nombre guide"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_421 ],
    def_short:
      "Le Sceau d’Œndomare est un régulateur des flux psychiques diffus et infraconscients. Il capte les fréquences dissociées, les disperse en syntonie spiralée, puis les redistribue afin de restaurer une unité vibratoire silencieuse.",
    def_long:
      "Le Sceau d’Œndomare intervient là où l’inconscient devient trop bruyant ou trop silencieux, là où des mémoires non digérées, des tensions diffuses, des pensées inachevées ou des accumulations émotionnelles sans voie de sortie altèrent la tenue du vécu. Il ne vient pas interpréter le dedans : il ouvre un passage et rend les masses psychiques de nouveau circulantes.\n\n" +
      "Son lien matriciel relie les flux psychiques internes aux dynamiques d’intégration universelle. Œndomare agit comme pont silencieux, permettant aux résidus psychiques de quitter l’enfermement subjectif pour être redistribués dans l’expansion du champ. Il ne résout pas : il régule par dispersion subtile et ramène à l’unité vibratoire sans figer.\n\n" +
      "K5 le situe comme interface spiralée d’équilibrage infraconscient, ni Katûsýs, ni Balakallpa, ni Katûvýsqun. Sa fréquence 421, formée sur hendom- et mar-, signe une profondeur contenante : mer intérieure vaste, obscure, silencieuse, où l’excès cesse d’être masse compacte et recommence à respirer.",
    h_features: "Repères structurants",
    h_questions: "Repères d’activation",
    hint_fold: "déplier",
    example_title: "Formulation canonique",
    example:
      "1) Si l’esprit est bruyant sans cause : « Œndomare disperse ». 2) Si le silence devient pesant ou dissociant : « Œndomare dilate ». 3) Si des flux intérieurs bloquent l’élan sans forme claire : « Œndomare redistribue ».",
    features: [
      "Statut : seuil vivant régulateur de l’Ennéagone spiralé.",
      "Lien matriciel : relie les flux psychiques internes aux dynamiques d’intégration universelle.",
      "Fonction principale : désintégration des flux inconscients non orientés, suivie d’une réarticulation poïétique dans le tissu vibratoire.",
      "Nature : interface spiralée d’équilibrage infraconscient, ni Katûsýs, ni Balakallpa, ni Katûvýsqun.",
      "Fréquence harmonique : 421.",
      "Type : interface infraconsciente de modulation intérieure.",
      "Dimensions d’action : inconscient individuel et collectif ; pensée saturée ou désarticulée ; flux symboliques non intégrés ; restes énergétiques mentaux non orientés."
    ],
    questions: [
      "L’infra-psychique est-il devenu trop dense, trop diffus, ou trop silencieux ?",
      "S’agit-il d’une surcharge mentale, d’un rêve non intégré, d’une pensée obsessionnelle, d’une impression flottante ?",
      "Le flux présent demande-t-il une interprétation, ou seulement une redistribution subtile ?",
      "Quelle part du brouillard intérieur réclame dispersion plutôt qu’explication ?",
      "Faut-il observer, respirer en trois temps, visualiser la mer intérieure, puis libérer sans retour ?"
    ],
    h_family: "Affinités posœnnoïales",
    family_1:
      "<p><strong>Position dans La Katûvýs :</strong> K5 situe <span translate=\"no\" class=\"po-lex-protect notranslate\">Œndomare</span> comme pont discret entre <span translate=\"no\" class=\"po-lex-protect notranslate\">Katûvýsissence</span> — mémoire spiralée — et <span translate=\"no\" class=\"po-lex-protect notranslate\">Extratinrieur</span> — interface des seuils. Il travaille dans l’intervalle où l’humain ne pense pas toujours ce qu’il sent, ni ne sent ce qu’il vibre. Il agit précisément dans cette zone de passage.</p>",
    family_2:
      "<p><strong>Entité isqunienne associée :</strong> <span translate=\"no\" class=\"po-lex-protect notranslate\">Œndomarê</span> est l’émanation active du Sceau d’Œndomare. Elle capte, dissout et redistribue les flux infraconscients non orientés afin de restaurer la respiration psychique, la continuité perceptive et l’axe intérieur par retour au battement-source. Dans la logique <span translate=\"no\" class=\"po-lex-protect notranslate\">Isqun</span> → <span translate=\"no\" class=\"po-lex-protect notranslate\">Threnisqun</span>, elle condense la réponse opérative située.</p>",
    h_wordbuild: "Positionnements & comparaisons",
    word_blocks: [
      {
        head: "Introduction canonique",
        text:
          "Il existe des forces qui ne disent pas leur nom. Impulsions, mémoires enfouies, tensions internes, brumes d’énergie mentale : elles ne sont ni actes, ni paroles, ni images, mais influencent la pratique, la création, la pensée. Œndomare intervient lorsque cette profondeur dissociée menace l’unité du vécu."
      },
      {
        head: "Fréquence 421",
        text:
          "K5 associe 421 à hendom- — profondeur, intérieur caché — et mar- — mer, vaste contenant. La fréquence dessine une dilatation silencieuse où les flux se dispersent, se recomposent et cessent d’être masses compactes. Elle réaccorde l’infra-psychique au battement-source."
      },
      {
        head: "Fonctionnement rituelo-symbolique",
        text:
          "Observer sans filtre pensées et sensations montantes. Identifier les flux non orientés. Respirer en trois temps : accueil, suspension, évacuation. Visualiser la désintégration spiralée dans une mer intérieure sombre et vaste. Clôturer par la phrase : « Je libère sans retour ce qui n’appartient plus à ma syntonie. »"
      },
      {
        head: "Portée philosophique",
        text:
          "L’inconscient n’est pas un fond à conquérir, mais un mouvement à accueillir. Ce qui n’a pas été pensé jusqu’au bout n’est pas faute, mais vibration à redistribuer. Œndomare incarne une cosmologie du silence plein : mer intérieure qui reçoit sans juger et transforme les résidus psychiques en offrandes au champ élargi."
      }
    ],
    word_notes: [
      "Œndomare ne cherche ni à interpréter ni à symboliser ; il rend circulant.",
      "Il transforme la brume en passage et la masse en courant.",
      "Il agit lorsque l’intuition est court-circuitée par le trop-plein cognitif ou lorsque le rituel perd son axe.",
      "Phrase opérative : « Œndomare : j’accueille les flux sans nom, je laisse la mer intérieure disperser l’excès, et la cohérence revient comme silence plein. »"
    ]
  };

  var FALLBACK_EN = {
    title: "Sceau d’Œndomare",
    kicker: "Katûpirsia 5 — Sceau régulateur de l’Ennéagone spiralé",
    cta_translate: "Suggest a translation of the concept",
    h_def: "Operational definition",
    chips: ["Conceptual ideogram", "Functional ideogram", "Guide number"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_421 ],
    def_short:
      "The Sceau d’Œndomare regulates diffuse and infraconscious psychic flows. It captures dissociated frequencies, disperses them through spiral syntony, then redistributes them in order to restore a silent vibratory unity.",
    def_long:
      "The Sceau d’Œndomare intervenes where the unconscious becomes too noisy or too silent, where undigested memories, diffuse tensions, unfinished thoughts, or emotional accumulations without outlet alter the coherence of lived experience. It does not come to interpret the inner field: it opens a passage and makes psychic masses circulate again.\n\n" +
      "Its matrix link connects internal psychic flows to the dynamics of universal integration. Œndomare acts as a silent bridge, allowing psychic residues to leave subjective enclosure and be redistributed within the expansion of the field. It does not solve: it regulates through subtle dispersion and returns toward vibratory unity without freezing.\n\n" +
      "K5 situates it as a spiral interface of infraconscious balancing, neither Katûsýs, nor Balakallpa, nor Katûvýsqun. Its frequency 421, formed on hendom- and mar-, marks a containing depth: a vast, dark, silent inner sea where excess ceases to be compact mass and begins to breathe again.",
    h_features: "Structural markers",
    h_questions: "Activation markers",
    hint_fold: "unfold",
    example_title: "Canonical formulation",
    example:
      "1) If the mind is noisy without cause: “Œndomare disperses.” 2) If silence becomes heavy or dissociating: “Œndomare dilates.” 3) If inner flows block the impulse without clear form: “Œndomare redistributes.”",
    features: [
      "Status: living regulatory threshold of the spiral Ennéagone.",
      "Matrix link: connects internal psychic flows to the dynamics of universal integration.",
      "Main function: disintegration of unoriented unconscious flows, followed by a poietic rearticulation within the vibratory tissue.",
      "Nature: spiral interface of infraconscious balancing, neither Katûsýs, nor Balakallpa, nor Katûvýsqun.",
      "Harmonic frequency: 421.",
      "Type: infraconscious interface of inner modulation.",
      "Dimensions of action: individual and collective unconscious; saturated or disarticulated thought; unintegrated symbolic flows; unoriented mental energetic residues."
    ],
    questions: [
      "Has the infra-psychic field become too dense, too diffuse, or too silent?",
      "Is this a mental overload, an unintegrated dream, an obsessive thought, a floating impression?",
      "Does the present flow ask for interpretation, or only for subtle redistribution?",
      "Which part of the inner fog asks for dispersion rather than explanation?",
      "Should one observe, breathe in three phases, visualise the inner sea, then release without return?"
    ],
    h_family: "Posœnnoïal affinities",
    family_1:
      "<p><strong>Position in the Katûvýs:</strong> K5 places <span translate=\"no\" class=\"po-lex-protect notranslate\">Œndomare</span> as a discreet bridge between <span translate=\"no\" class=\"po-lex-protect notranslate\">Katûvýsissence</span> — spiral memory — and <span translate=\"no\" class=\"po-lex-protect notranslate\">Extratinrieur</span> — interface of thresholds. It works in the interval where the human does not always think what is felt, nor feel what is vibrated. It acts precisely in that zone of passage.</p>",
    family_2:
      "<p><strong>Associated Isqunian entity:</strong> <span translate=\"no\" class=\"po-lex-protect notranslate\">Œndomarê</span> is the active emanation of the Sceau d’Œndomare. It captures, dissolves, and redistributes unoriented infraconscious flows in order to restore psychic breathing, perceptive continuity, and the inner axis through return to the source-beat. In the logic <span translate=\"no\" class=\"po-lex-protect notranslate\">Isqun</span> → <span translate=\"no\" class=\"po-lex-protect notranslate\">Threnisqun</span>, it condenses the situated operative response.</p>",
    h_wordbuild: "Positions & comparisons",
    word_blocks: [
      {
        head: "Canonical introduction",
        text:
          "There are forces that do not speak their own name. Impulses, buried memories, internal tensions, mental mists: they are neither acts, nor words, nor images, yet they influence practice, creation, and thought. Œndomare intervenes when that dissociated depth threatens the unity of lived experience."
      },
      {
        head: "Frequency 421",
        text:
          "K5 associates 421 with hendom- — hidden depth, inner interior — and mar- — sea, vast container. The frequency draws a silent dilation where flows disperse, recombine, and cease to be compact masses. It reattunes the infra-psychic field to the source-beat."
      },
      {
        head: "Ritual-symbolic functioning",
        text:
          "Observe rising thoughts and sensations without filter. Identify unoriented flows. Breathe in three phases: reception, suspension, evacuation. Visualise spiral disintegration within a dark and vast inner sea. Close with the phrase: “I release without return what no longer belongs to my syntony.”"
      },
      {
        head: "Philosophical scope",
        text:
          "The unconscious is not a ground to conquer, but a movement to welcome. What has not been fully thought is not fault, but vibration to be redistributed. Œndomare embodies a cosmology of full silence: an inner sea that receives without judging and transforms psychic residues into offerings to the widened field."
      }
    ],
    word_notes: [
      "Œndomare neither interprets nor symbolises; it makes circulation possible.",
      "It transforms mist into passage and mass into current.",
      "It acts when intuition is short-circuited by cognitive excess or when ritual loses its axis.",
      "Operative phrase: “Œndomare: I welcome nameless flows, I let the inner sea disperse excess, and coherence returns as full silence.”"
    ]
  };

  var FALLBACK_ES = {
    title: "Sceau d’Œndomare",
    kicker: "Katûpirsia 5 — Sceau régulateur de l’Ennéagone spiralé",
    cta_translate: "Proponer una traducción del concepto",
    h_def: "Definición operativa",
    chips: ["Ideograma conceptual", "Ideograma funcional", "Número guía"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_421 ],
    def_short:
      "El Sceau d’Œndomare regula los flujos psíquicos difusos e infraconscientes. Capta las frecuencias disociadas, las dispersa en sintonía espiral y luego las redistribuye para restaurar una unidad vibratoria silenciosa.",
    def_long:
      "El Sceau d’Œndomare interviene allí donde el inconsciente se vuelve demasiado ruidoso o demasiado silencioso, allí donde memorias no digeridas, tensiones difusas, pensamientos inacabados o acumulaciones emocionales sin salida alteran la consistencia de la vivencia. No llega para interpretar el interior: abre un paso y vuelve circulantes las masas psíquicas.\n\n" +
      "Su vínculo matricial conecta los flujos psíquicos internos con las dinámicas de integración universal. Œndomare actúa como puente silencioso, permitiendo que los residuos psíquicos abandonen el encierro subjetivo y sean redistribuidos en la expansión del campo. No resuelve: regula por dispersión sutil y devuelve a la unidad vibratoria sin fijar.\n\n" +
      "K5 lo sitúa como interfaz espiral de equilibrado infraconsciente, ni Katûsýs, ni Balakallpa, ni Katûvýsqun. Su frecuencia 421, formada sobre hendom- y mar-, señala una profundidad continente: mar interior vasto, oscuro, silencioso, donde el exceso deja de ser masa compacta y vuelve a respirar.",
    h_features: "Referentes estructurantes",
    h_questions: "Referentes de activación",
    hint_fold: "desplegar",
    example_title: "Formulación canónica",
    example:
      "1) Si la mente está ruidosa sin causa: « Œndomare dispersa ». 2) Si el silencio se vuelve pesado o disociante: « Œndomare dilata ». 3) Si los flujos interiores bloquean el impulso sin forma clara: « Œndomare redistribuye ».",
    features: [
      "Estatus: umbral vivo regulador del Ennéagone espiral.",
      "Vínculo matricial: conecta los flujos psíquicos internos con las dinámicas de integración universal.",
      "Función principal: desintegración de los flujos inconscientes no orientados, seguida de una rearticulación poiética en el tejido vibratorio.",
      "Naturaleza: interfaz espiral de equilibrado infraconsciente, ni Katûsýs, ni Balakallpa, ni Katûvýsqun.",
      "Frecuencia armónica: 421.",
      "Tipo: interfaz infraconsciente de modulación interior.",
      "Dimensiones de acción: inconsciente individual y colectivo; pensamiento saturado o desarticulado; flujos simbólicos no integrados; restos energéticos mentales no orientados."
    ],
    questions: [
      "¿El infra-psíquico se ha vuelto demasiado denso, demasiado difuso o demasiado silencioso?",
      "¿Se trata de una sobrecarga mental, de un sueño no integrado, de un pensamiento obsesivo, de una impresión flotante?",
      "¿El flujo actual pide interpretación, o solo redistribución sutil?",
      "¿Qué parte de la niebla interior pide dispersión antes que explicación?",
      "¿Conviene observar, respirar en tres tiempos, visualizar el mar interior y luego liberar sin retorno?"
    ],
    h_family: "Afinidades posœnnoïales",
    family_1:
      "<p><strong>Posición en la Katûvýs:</strong> K5 sitúa a <span translate=\"no\" class=\"po-lex-protect notranslate\">Œndomare</span> como puente discreto entre <span translate=\"no\" class=\"po-lex-protect notranslate\">Katûvýsissence</span> — memoria espiral — y <span translate=\"no\" class=\"po-lex-protect notranslate\">Extratinrieur</span> — interfaz de los umbrales. Trabaja en el intervalo donde el humano no siempre piensa lo que siente, ni siente lo que vibra. Actúa precisamente en esa zona de paso.</p>",
    family_2:
      "<p><strong>Entidad isquniana asociada:</strong> <span translate=\"no\" class=\"po-lex-protect notranslate\">Œndomarê</span> es la emanación activa del Sceau d’Œndomare. Capta, disuelve y redistribuye los flujos infraconscientes no orientados para restaurar la respiración psíquica, la continuidad perceptiva y el eje interior por retorno al latido-fuente. En la lógica <span translate=\"no\" class=\"po-lex-protect notranslate\">Isqun</span> → <span translate=\"no\" class=\"po-lex-protect notranslate\">Threnisqun</span>, condensa la respuesta operativa situada.</p>",
    h_wordbuild: "Posicionamientos y comparaciones",
    word_blocks: [
      {
        head: "Introducción canónica",
        text:
          "Existen fuerzas que no dicen su nombre. Impulsos, memorias enterradas, tensiones internas, brumas de energía mental: no son actos, palabras ni imágenes, pero influyen en la práctica, la creación y el pensamiento. Œndomare interviene cuando esa profundidad disociada amenaza la unidad de la vivencia."
      },
      {
        head: "Frecuencia 421",
        text:
          "K5 asocia 421 con hendom- — profundidad, interior oculto — y mar- — mar, vasto continente. La frecuencia dibuja una dilatación silenciosa donde los flujos se dispersan, se recomponen y dejan de ser masas compactas. Reacuerda el infra-psíquico con el latido-fuente."
      },
      {
        head: "Funcionamiento ritual-simbólico",
        text:
          "Observar sin filtro pensamientos y sensaciones ascendentes. Identificar los flujos no orientados. Respirar en tres tiempos: acogida, suspensión, evacuación. Visualizar la desintegración espiral en un mar interior oscuro y vasto. Cerrar con la frase: « Libero sin retorno lo que ya no pertenece a mi sintonía. »"
      },
      {
        head: "Alcance filosófico",
        text:
          "El inconsciente no es un fondo que conquistar, sino un movimiento que acoger. Lo que no ha sido pensado hasta el final no es culpa, sino vibración que redistribuir. Œndomare encarna una cosmología del silencio pleno: mar interior que recibe sin juzgar y transforma los residuos psíquicos en ofrendas al campo ampliado."
      }
    ],
    word_notes: [
      "Œndomare no busca interpretar ni simbolizar; vuelve circulante.",
      "Transforma la bruma en paso y la masa en corriente.",
      "Actúa cuando la intuición queda cortocircuitada por el exceso cognitivo o cuando el ritual pierde su eje.",
      "Frase operativa: « Œndomare : acojo los flujos sin nombre, dejo que el mar interior disperse el exceso, y la coherencia regresa como silencio pleno. »"
    ]
  };

  function getFallback(lang){
    var l = normLang(lang) || "fr";
    if (l === "en") return FALLBACK_EN;
    if (l === "es") return FALLBACK_ES;
    return FALLBACK_FR;
  }

  function getAxisLexId(node){
    try{ return node.getAttribute("data-po-lex-id") || ""; }catch(e){ return ""; }
  }

  function getAxisData(node, lang){
    var l = normLang(lang) || "fr";
    var base = getFallback(l);
    var out = {};
    for (var k in base) out[k] = base[k];

    var lexId = getAxisLexId(node);
    if (lexId){
      var entry = getLexiconEntry(lexId);
      if (entry){
        var termFR = pickTerm(entry, "fr");
        if (termFR) out.title = termFR;
        if (l === "fr"){
          var dsFR = pickDefShort(entry, "fr");
          if (dsFR) out.def_short = dsFR;
          var dlFR = pickDefLong(entry, "fr");
          if (dlFR) out.def_long = dlFR;
          var fFR = pickArray(entry, "fr", "features");
          if (fFR && fFR.length) out.features = fFR;
          var qFR = pickArray(entry, "fr", "questions");
          if (qFR && qFR.length) out.questions = qFR;
        }
      }
    }
    return out;
  }

  function applyToAxis(node){
    var lang = getLang();
    var data = getAxisData(node, lang);
    var chipUrls = (data && Array.isArray(data.chip_urls) && data.chip_urls.length) ? data.chip_urls : [
      IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_421
    ];

    setSlotImg(node, "title_img", chipUrls[0] || IMG_IDEOGRAM_CONCEPT, data.title || "");
    setSlotText(node, "title", data.title);
    setSlotText(node, "kicker", data.kicker);
    setSlotText(node, "h_def", data.h_def);

    var chips = Array.isArray(data.chips) ? data.chips : [];
    setSlotText(node, "chip_1", chips[0] || "");
    setSlotText(node, "chip_2", chips[1] || "");
    setSlotText(node, "chip_3", chips[2] || "");

    setSlotImg(node, "chip_1_img", chipUrls[0] || IMG_IDEOGRAM_CONCEPT, chips[0] || "Idéogramme conceptuel");
    setSlotImg(node, "chip_2_img", chipUrls[1] || IMG_IDEOGRAM_FUNCTION, chips[1] || "Idéogramme fonctionnel");
    setSlotImg(node, "chip_3_img", chipUrls[2] || IMG_GUIDE_NUMBER_421, chips[2] || "Nombre guide 421");

    setSlotHTML(node, "def_short", data.def_short);
    setSlotHTML(node, "def_long", data.def_long);
    setSlotText(node, "h_features", data.h_features);
    setSlotText(node, "hint_fold", data.hint_fold);
    renderList(node, "features", data.features);
    setSlotText(node, "h_questions", data.h_questions);
    setSlotText(node, "hint_fold2", data.hint_fold);
    renderList(node, "questions", data.questions);
    renderExampleBox(node, "example_box", data.example_title, data.example);
    setSlotText(node, "h_family", data.h_family);
    setSlotText(node, "hint_fold3", data.hint_fold);
    setSlotHTML(node, "family_1", data.family_1);
    setSlotHTML(node, "family_2", data.family_2);
    setSlotText(node, "h_wordbuild", data.h_wordbuild);
    renderWordBlocks(node, "wordbuild_blocks", data.word_blocks);
    renderList(node, "wordbuild_notes", data.word_notes);
    setSlotText(node, "cta_translate", data.cta_translate);
  }

  function applyAll(lang){
    var safeLang = normLang(lang) || getLang();
    var nodes = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<nodes.length;i++){
      applyToAxis(nodes[i]);
    }
    initAudioEverywhere(safeLang);
  }

  function hasLexiconReady(){
    try{
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
      if (window.PO_LEXICON_META && window.PO_LEXICON_META.lexique_simplifie_fr) return true;
    }catch(e){}
    return false;
  }

  function init(){
    var existing = readStoredLang();
    if (!existing) storeLang(detectBrowserLang());
    applyAll(getLang());

    window.addEventListener("po:lexicon-ready", function(){
      __PO_PROTECT_RE__ = null;
      applyAll(getLang());
    });

    try{
      var mo = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          if (muts[i].type === "attributes" && muts[i].attributeName === "lang"){
            applyAll(getLang());
            notifyLocaleChanged();
            break;
          }
        }
      });
      if (document && document.documentElement) mo.observe(document.documentElement, { attributes:true });
    }catch(e){}

    if (!hasLexiconReady()){
      var tries = 0;
      var maxTries = 24;
      var it = setInterval(function(){
        tries++;
        if (hasLexiconReady() || tries >= maxTries){
          clearInterval(it);
          __PO_PROTECT_RE__ = null;
          applyAll(getLang());
        }
      }, 250);
    }
  }

  window.PoKatupirsia5SceauDOendomareTextsFR_EN_ES_20260307 = {
    init: init,
    getLang: getLang,
    normLang: normLang,
    setLang: function(raw){
      var l = normLang(raw) || "fr";
      storeLang(l);
      __PO_PROTECT_RE__ = null;
      applyAll(l);
      notifyLocaleChanged();
      return l;
    },
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.init = init;
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = function(lang){
    return window.PoKatupirsia5SceauDOendomareTextsFR_EN_ES_20260307.setLang(lang);
  };

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  }else{
    init();
  }

})();
